import React from 'react';
import './EllaCartSkeleton.style.scss';

const EllaCartSkeleton = (): JSX.Element => {
  return (
    <div className='EllaCart-skeleton'>
      {[100, 80, 60, 40].map((width, index) => (
        <div
          key={index}
          className='EllaCart-skeleton-rectangle'
          style={{ width: `${width}%` }}
        />
      ))}
    </div>
  );
};

export default EllaCartSkeleton;
